import { sanctioned_individual } from '@axo/shared/data-access/types';

export const sanctionedIndividualKeys = {
  root: {
    service: 'sanctioned-user',
  } as const,
  find: (request: sanctioned_individual.FindSactionsRequest) =>
    ({
      ...sanctionedIndividualKeys.root,
      endpoint: 'find',
      request,
    }) as const,
};
